import { render } from "./adminPerfilesPermisosForm-Component.vue?vue&type=template&id=9d7fc774&scoped=true"
import script from "./adminPerfilesPermisosForm-Component.vue?vue&type=script&lang=js"
export * from "./adminPerfilesPermisosForm-Component.vue?vue&type=script&lang=js"

import "./adminPerfilesPermisosForm-Component.vue?vue&type=style&index=0&id=9d7fc774&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7fc774"]])

export default __exports__